/*
 * Created with IntelliJ IDEA.
 * User: elanh
 * Date: 6/5/13
 * Time: 1:43 PM
 */

/*
 ColorPickerModel
 This model holds data for a color picker and handles translation of colors between different formats:
 Hex -> RGB -> HSB
 */

define(function (require) {
    "use strict";

    var $ = require("jquery");
    var _ = require("underscore");
    var Backbone = require("backbone");
    var HEX_WHITE = "#ffffff";
    var HEX_BLACK = "#000000";


    var DEFAULTS = {
        RGB : {
            r : 0,
            g : 0,
            b : 0
        },
        HSB : {
            h : 0,
            s : 100,
            b : 0
        },
        Hex : HEX_BLACK,
        isTransparent : false
    };

    var ColorPickerModel = Backbone.Model.extend({
        defaults : DEFAULTS,
        ranges : {
            RGB : {
                min : 0,
                max : 255
            },
            HSB : {
                h : {
                    min : 0,
                    max : 360
                },
                s : {
                    min : 0,
                    max : 100
                },
                b : {
                    min : 0,
                    max : 100
                }
            }
        },
        shorthands: {
            "#fff": "#ffffff",
            "#000": "#000000"
        },

        initialize : function (options) {},

        setHex : function (hex) {
            if (!_.isUndefined(hex) && (hex !== this.getHex())){
                hex = this.shorthands[hex] || hex;
                var rgb = this.HexToRGB(hex);
                var hsb = this.HexToHSB(hex);
                this._setAll(hex, rgb, hsb, false);
            }
        },
        getHex : function () {
            return this.get("Hex");
        },
        _formatHex : function(hex){
            return hex;
        },
        setRGB : function (rgb) {
            var current = this.getRGB();
            //use current values for those that are not updated
            var update = _.defaults(rgb, current);
            var hex = this.RGBToHex(update);
            var hsb = this.RGBToHSB(update);
            this._setAll(hex, update, hsb, false);
        },
        getRGB : function () {
            return this.get("RGB");
        },
        isBlackOrWhite: function(){
            var hex = this.getHex();
            return (hex === HEX_BLACK || hex === HEX_WHITE);
        },
        _formatRGB : function(rgb){
            _.each(rgb, function(value, key, rgb){
                rgb[key] = this._forceRange(value, this.ranges.RGB.min, this.ranges.RGB.max);
                rgb[key] = Math.round(rgb[key]);
            }, this);

            return rgb;
        },
        setHSB : function (hsb, needUpdate) {
            var current = this.getHSB();
            //use current values for those that are not updated
            var update = _.defaults(hsb, current);
            var hex = this.HSBToHex(update);
            var rgb = this.HSBToRGB(update);
            this._setAll(hex, rgb, update, false, needUpdate);
        },
        getHSB : function () {
            return this.get("HSB");
        },
        _formatHSB : function(hsb){
            _.each(hsb, function(value, key, hsb){
                hsb[key] = this._forceRange(value, this.ranges.HSB[key].min, this.ranges.HSB[key].max);
                hsb[key] = Math.round(hsb[key]);
            }, this);
            return hsb;
        },

        setIsTransparent : function (isTransparent) {
            this.set("isTransparent", isTransparent);
        },
        isTransparent : function(){
            return this.get("isTransparent");
        },

        _setAll : function (hex, rgb, hsb, isTransparent, needUpdate) {
            //validate/format hex
            var prevHex = this.getHex();
            hex = this._formatHex(hex);
            //validate/format rgb
            rgb = this._formatRGB(rgb);
            //validate/format hsb
            hsb = this._formatHSB(hsb);

            if (_.isUndefined(needUpdate) || needUpdate){
            //if (!!needUpdate){
                this.set({
                    RGB : rgb,
                    HSB : hsb,
                    Hex : hex,
                    isTransparent: isTransparent
                });
            }
            else {
                this.trigger("change:Hex", null, hex);
            }
        },

        _forceRange : function(value, min, max){
            return Math.max(min, Math.min(value, max));
        },
        HexToRGB : function (hex) {
            hex = parseInt(((hex.indexOf("#") > -1) ? hex.substring(1) : hex), 16);
            return {r : hex >> 16, g : (hex & 0x00FF00) >> 8, b : (hex & 0x0000FF)};
        },
        HexToHSB : function (hex) {
            return this.RGBToHSB(this.HexToRGB(hex));
        },
        RGBToHSB : function (rgb) {
            var hsb = {
                h : 0,
                s : 0,
                b : 0
            };
            var min = Math.min(rgb.r, rgb.g, rgb.b);
            var max = Math.max(rgb.r, rgb.g, rgb.b);
            var delta = max - min;
            hsb.b = max;
            hsb.s = max !== 0 ? 255 * delta / max : 0;
            if (hsb.s !== 0) {
                if (rgb.r == max) {
                    hsb.h = (rgb.g - rgb.b) / delta;
                } else if (rgb.g == max) {
                    hsb.h = 2 + (rgb.b - rgb.r) / delta;
                } else {
                    hsb.h = 4 + (rgb.r - rgb.g) / delta;
                }
            } else {
                hsb.h = -1;
            }
            hsb.h *= 60;
            if (hsb.h < 0) {
                hsb.h += 360;
            }
            hsb.s *= 100 / 255;
            hsb.b *= 100 / 255;
            return hsb;
        },
        HSBToRGB : function (hsb) {
            var rgb = {};
            var h = Math.round(hsb.h);
            var s = Math.round(hsb.s * 255 / 100);
            var v = Math.round(hsb.b * 255 / 100);
            if (s === 0) {
                rgb.r = rgb.g = rgb.b = v;
            } else {
                var t1 = v;
                var t2 = (255 - s) * v / 255;
                var t3 = (t1 - t2) * (h % 60) / 60;
                if (h == 360) {
                    h = 0;
                }
                if (h < 60) {
                    rgb.r = t1;
                    rgb.b = t2;
                    rgb.g = t2 + t3;
                } else if (h < 120) {
                    rgb.g = t1;
                    rgb.b = t2;
                    rgb.r = t1 - t3;
                } else if (h < 180) {
                    rgb.g = t1;
                    rgb.r = t2;
                    rgb.b = t2 + t3;
                } else if (h < 240) {
                    rgb.b = t1;
                    rgb.r = t2;
                    rgb.g = t1 - t3;
                } else if (h < 300) {
                    rgb.b = t1;
                    rgb.g = t2;
                    rgb.r = t2 + t3;
                } else if (h < 360) {
                    rgb.r = t1;
                    rgb.g = t2;
                    rgb.b = t1 - t3;
                } else {
                    rgb.r = 0;
                    rgb.g = 0;
                    rgb.b = 0;
                }
            }
            return {r : Math.round(rgb.r), g : Math.round(rgb.g), b : Math.round(rgb.b)};
        },
        RGBToHex : function (rgb) {
            var hex = [
                rgb.r.toString(16), rgb.g.toString(16), rgb.b.toString(16)
            ];
            $.each(hex, function (nr, val) {
                if (val.length == 1) {
                    hex[nr] = "0" + val;
                }
            });
            return "#" + hex.join("");
        },
        HSBToHex : function (hsb) {
            return this.RGBToHex(this.HSBToRGB(hsb));
        }
    });

    return ColorPickerModel;
});

